import { createUpdateTool, } from '@debbie/common/dist/agents/tools/create-update.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useUpdateTypes } from '@debbie/cortex/dist/update-types/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import Errors from '../Errors.js';
import Edit2 from '../Icons/Edit2.js';
import X from '../Icons/X.js';
import PlaceholderLoader from '../PlaceholderLoader.js';
import Select from '../Select.js';
import Textarea from '../Textarea.js';
import Procedure from '../Workflows/Procedure.js';
import { Body, EditError, IconButton, Inline, Pill, Section, SectionLabel, SectionValue, useProposalEdits, } from './shared.js';
const TopRow = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
`;
const UpdateTypeHeadline = styled.div `
  font-size: 1.15em;
  font-weight: 700;
  color: ${THEME.COLOR_PRIMARY};
  word-break: break-word;
`;
const CreateUpdateBody = ({ input, onEditsChange }) => {
    const lang = useSelector((s) => s.lang);
    const updateTypesLoadable = useUpdateTypes();
    const [editing, setEditing] = useState(false);
    const [updateText, setUpdateText] = useState(input.update ?? '');
    const [continuation, setContinuation] = useState(input.continueAt === 'NOW' ? 'NOW' : input.continueAt ? 'LEGACY' : 'PAUSED');
    const { patch, editError, emit } = useProposalEdits(createUpdateTool, input, onEditsChange);
    if (h.isError(updateTypesLoadable)) {
        return React.createElement(Errors, { errors: [updateTypesLoadable.error.message] });
    }
    if (!h.hasData(updateTypesLoadable)) {
        return React.createElement(PlaceholderLoader, null);
    }
    const updateType = updateTypesLoadable.data.find((t) => t.updateTypeId === input.updateTypeId);
    const label = lang.updateTypes[input.updateTypeId] ??
        updateType?.label ??
        lang.agentProposalBodies.unknownUpdateType;
    const updateContinuation = (value) => {
        setContinuation(value);
        const next = value === 'NOW' ? 'NOW' : value === 'LEGACY' ? input.continueAt : null;
        if (next === input.continueAt ||
            (next == null && input.continueAt == null)) {
            delete patch.current.continueAt;
        }
        else {
            patch.current.continueAt = next;
        }
        emit();
    };
    const cancelEditing = () => {
        setUpdateText(input.update ?? '');
        setContinuation(input.continueAt === 'NOW'
            ? 'NOW'
            : input.continueAt
                ? 'LEGACY'
                : 'PAUSED');
        patch.current = {};
        emit();
        setEditing(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Section, null,
            React.createElement(SectionLabel, null, lang.agentProposalBodies.updateType),
            React.createElement(TopRow, null,
                React.createElement(UpdateTypeHeadline, null, label),
                onEditsChange != null && (React.createElement(IconButton, { onClick: editing ? cancelEditing : () => setEditing(true), title: editing ? lang.misc.cancel : lang.misc.edit }, editing ? React.createElement(X, { size: "16px" }) : React.createElement(Edit2, { size: "16px" }))))),
        editing ? (React.createElement(React.Fragment, null,
            React.createElement(Section, null,
                React.createElement(Select, { label: lang.agentProposalBodies.continuation, value: continuation, onChange: (event) => updateContinuation(event.target.value) },
                    React.createElement("option", { value: "NOW" }, lang.agentProposalBodies.continueNow),
                    updateType?.pausing && (React.createElement("option", { value: "PAUSED" }, lang.agentProposalBodies.leavePaused)),
                    input.continueAt && input.continueAt !== 'NOW' && (React.createElement("option", { value: "LEGACY" },
                        lang.agentProposalBodies.keepScheduledDate,
                        ":",
                        ' ',
                        input.continueAt)))),
            React.createElement(Section, null,
                React.createElement(Textarea, { placeholder: lang.agentProposalBodies.updateText, value: updateText, style: { minHeight: '80px' }, onChange: (event) => {
                        const value = event.target.value;
                        setUpdateText(value);
                        if (value === (input.update ?? '')) {
                            delete patch.current.update;
                        }
                        else {
                            patch.current.update = value || null;
                        }
                        emit();
                    } })),
            editError && (React.createElement(EditError, null,
                lang.agentProposals.invalidEdits,
                ": ",
                editError)))) : (React.createElement(React.Fragment, null,
            input.continueAt && (React.createElement(Section, null,
                React.createElement(Inline, null,
                    React.createElement(Pill, null,
                        lang.updates.pauseContinueAt,
                        ": ",
                        input.continueAt)))),
            input.update && (React.createElement(Section, null,
                React.createElement(SectionLabel, null, lang.agentProposalBodies.updateText),
                React.createElement(Body, null, input.update))),
            !input.update && !input.continueAt && (React.createElement(Section, null,
                React.createElement(SectionValue, null, lang.agentProposalBodies.noDetails))))),
        updateType?.procedureEnabled &&
            updateType.procedure &&
            updateType.procedure.length > 0 && (React.createElement(Section, null,
            React.createElement(SectionLabel, null, lang.agentProposalBodies.procedureTasks),
            React.createElement(Procedure, { procedure: updateType.procedure })))));
};
export default CreateUpdateBody;
//# sourceMappingURL=CreateUpdateBody.js.map